import React from "react";
import { COLORS, FONT, cardStyle, sectionHintStyle, sectionTitleStyle } from "./theme";

/**
 * Card do dashboard: superfície branca, borda hairline, título e dica.
 *
 * `action` é o canto superior direito (uma legenda, um seletor). `flex` controla
 * quanto o card ocupa numa linha — os blocos são flex-wrap, então numa tela
 * estreita cada um vira uma linha inteira sem media query.
 */
export default function Card({ title, hint, action, children, flex = "1 1 100%", minWidth = 300 }) {
  return (
    <section style={{ ...cardStyle, flex, minWidth, padding: "18px 20px 14px", boxSizing: "border-box" }}>
      {(title || action) && (
        <header
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 12,
            marginBottom: 14,
          }}
        >
          <div>
            {title && <h2 style={sectionTitleStyle}>{title}</h2>}
            {hint && <p style={sectionHintStyle}>{hint}</p>}
          </div>
          {action}
        </header>
      )}
      {children}
    </section>
  );
}

/**
 * Legenda de série: um ponto na cor da marca + o rótulo em tinta de texto.
 *
 * A identidade vem do ponto colorido AO LADO do texto, nunca de colorir o
 * texto: um verde ou violeta claro é ilegível como texto sobre o branco.
 */
export function LegendKey({ color, label }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontFamily: FONT,
        fontSize: 12,
        color: COLORS.inkSecondary,
      }}
    >
      <span
        style={{
          width: 9,
          height: 9,
          borderRadius: "50%",
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      {label}
    </span>
  );
}

/** Mensagem de bloco vazio — sem isso um card sem dados vira um retângulo mudo. */
export function EmptyBlock({ children, height = 120 }) {
  return (
    <div
      style={{
        height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: FONT,
        fontSize: 13,
        color: COLORS.inkMuted,
        textAlign: "center",
        padding: "0 16px",
      }}
    >
      {children}
    </div>
  );
}
